import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop"; 

import Home from "./views/Home";
import Workshops from "./views/Step10_Workshops";
import Address from "./views/Step20_Address";
import Checkout from "./views/Step50_Checkout";
import Confirmation from "./views/Step60_Confirmation";

import "./css/style.css";

function App() {
  return (
      <BrowserRouter>
          <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/de/home" replace />} />
        <Route path="/:language/home" element={<Home />} />
        <Route path="/:language/workshops" element={<Workshops />} />
        {/* entry point for buyers who already have an entrance ticket and only want to add workshops */}
        <Route path="/:language/workshops/direct" element={<Workshops standalone />} />
        <Route path="/:language/address" element={<Address />} />
        <Route path="/:language/checkout" element={<Checkout />} />
        <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
        <Route path="/:language/confirmation" element={<Confirmation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
